import React from 'react';
import classnames from 'classnames';

export interface DrawerContentProps {
  tag?: string;
  className?: string;
}

const DrawerContent: React.FunctionComponent<DrawerContentProps> = ({
  tag: Tag = 'div',
  children,
  className = '',
  ...otherProps
}) => {
  return (
    // https://github.com/Microsoft/TypeScript/issues/28892
    // @ts-ignore
    <Tag
      className={classnames('mdc-drawer__content', className)}
      {...otherProps}
    >
      {children}
    </Tag>
  );
};

export default DrawerContent;
